/**
 * Geo-detection + currency assignment.
 * Waterfall: localStorage cache → browser Geolocation → IP fallback → default "IN".
 * Cache TTL = 24h. Exchange rate cache TTL = 6h.
 */

const GEO_KEY = 'cognara_geo_country';
const FX_KEY = 'cognara_fx_rate';

const isFresh = (obj, ttlMs) => obj && obj.timestamp && (Date.now() - obj.timestamp) < ttlMs;

export async function detectCountry() {
  try {
    const cached = JSON.parse(localStorage.getItem(GEO_KEY) || 'null');
    if (isFresh(cached, 24 * 60 * 60 * 1000) && cached.country) return cached.country;
  } catch {}

  // 1. IP fallback (fast, no permission prompt). We deliberately skip the
  //    browser Geolocation prompt — it's intrusive for a pricing page.
  try {
    const r = await fetch('https://ipapi.co/json/', { cache: 'no-cache' });
    if (r.ok) {
      const j = await r.json();
      const cc = (j.country_code || '').toUpperCase();
      if (cc) {
        localStorage.setItem(GEO_KEY, JSON.stringify({ country: cc, timestamp: Date.now() }));
        return cc;
      }
    }
  } catch {}

  return 'IN';
}

export function currencyForCountry(cc) {
  return (cc || '').toUpperCase() === 'IN' ? 'INR' : 'USD';
}

export function currencySymbol(currency) {
  return currency === 'INR' ? '₹' : '$';
}

export async function fetchFxRate() {
  try {
    const cached = JSON.parse(localStorage.getItem(FX_KEY) || 'null');
    if (isFresh(cached, 6 * 60 * 60 * 1000) && cached.rate) return cached.rate;
  } catch {}
  try {
    const r = await fetch('https://api.exchangerate-api.com/v4/latest/USD');
    const j = await r.json();
    const rate = j?.rates?.INR;
    if (rate) {
      localStorage.setItem(FX_KEY, JSON.stringify({ rate, timestamp: Date.now() }));
      return rate;
    }
  } catch {}
  return 83.5;
}

export function formatMoney(amount, currency) {
  const sym = currencySymbol(currency);
  const n = Number(amount || 0);
  if (currency === 'INR') {
    return `${sym}${n.toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}`;
  }
  return `${sym}${n.toLocaleString('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}`;
}

export const COUNTRY_NAMES = {
  IN: 'India', US: 'United States', GB: 'United Kingdom', AE: 'UAE',
  SG: 'Singapore', AU: 'Australia', CA: 'Canada', DE: 'Germany',
};

export const COUNTRY_FLAGS = {
  IN: '🇮🇳', US: '🇺🇸', GB: '🇬🇧', AE: '🇦🇪', SG: '🇸🇬', AU: '🇦🇺', CA: '🇨🇦', DE: '🇩🇪',
};
